import {detailServicesPath} from "../../Constants";
import axios from "axios";

export const restUrl = detailServicesPath + '/organization/detail-reserve'

export default class DetailReserveService {
    static async resetContour(id) {
        return axios.patch(restUrl + '/' + id + '/reset-contour', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async getAll() {
        return axios.get(`${restUrl}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async get(reserveId) {
        return axios.get(`${restUrl}/${reserveId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(data) {
        return await axios.post(restUrl, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(id, data) {
        return await axios.patch(restUrl + '/' + id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async unableTurn(id, status) {
        return axios.patch(restUrl + '/' + id + '/unable-turn?status=' + status, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async unableCut(id, status) {
        return axios.patch(restUrl + '/' + id + '/unable-cut?status=' + status, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}